<template>
  <div class="inspectionRecord">
    <div class="mainContent" :style="styleObject">
      <div class="query">
        <!--         <el-select v-model="selectedName" placeholder="设备类型">-->
        <!--            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
        <!--         </el-select>-->
        <!--         <el-select v-model="selectedName" placeholder="报警区域">-->
        <!--            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
        <!--         </el-select>-->
        <el-select v-model="status" placeholder="巡检计划状态" clearable>
               <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
         <!-- <el-date-picker v-model="creatTime" type="monthrange" align="right" unlink-panels range-separator="至"  :picker-options="pickerOptions" value-format='yyyy-MM'>
         </el-date-picker> -->
         <el-date-picker
                v-model="creatTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
        <button v-if="rolePermit('polling:record:query')" class="primaryBtn" @click="serachData">查询</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading"
                    :current-page="pagination.page" @currentChange="handleRoleCurrentChange"
                    @sizeChange="handleRoleSizeChange">
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column prop="templateName" width="150" label="巡检计划名称"></el-table-column>
        <el-table-column prop="" width="450" label="巡检时间段" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.etime==null?scope.row.stime+"至今":scope.row.stime+"至"+scope.row.etime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="巡检状态">
          <template slot-scope="scope">
            <div>{{scope.row.recordStatus == 1 ? '进行中' : '已结束'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="巡检员"></el-table-column>
        <el-table-column prop="" label="巡检单操作" width="120" v-if="rolePermit('polling:record:query')">
          <template slot-scope="scope">
            <el-button @click="seeClick(scope.row)" size="small" :class="scope.row.status == 1 ? 'noedit' : 'edit'">查看</el-button>
          </template>
        </el-table-column>
      </border-table>
      <patrol-report v-if="dialogTableVisible" @closeReport="closeDialog" :propRow="dataOne"></patrol-report>
    </div>
  </div>
</template>

<script>
  import BorderTable from "@/components/common/BorderTable";
  import PatrolReport from "@/components/patrolManagement/PatrolReport";

  export default {
    components: {
      BorderTable,
      PatrolReport
    },
    data() {
      return {
         creatTime: [],
         pickerOptions: {
             shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }]
         },
        dataOne: {},
        dialogTableVisible: false,
        tableLoading: false,
        dataList: [],
        pagination: {
          show: true,
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        loading: false,
        drawerShow: false,
        drawerTitle: "",
        drawerWidth: "500px",
        status:'',
        options: [
          {
            value: "1",
            label: "进行中"
          },
          {
            value: "2",
            label: "已结束"
          }
        ],
        styleObject: {
          height: ""
        },
      };
    },
    created() {
      this.makeheight()
      this.creatTime=[new Date(new Date() - 3600 * 1000 * 24*30),new Date()]
      this.initData();
    },
    methods: {
       //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
      initData() {
        this.tableLoading = true;
        let date1=null
        let date2=null
        console.log(this.creatTime);
        
        if(this.creatTime.length){
           date1=this.timeInit.getYMDHMS(this.creatTime[0])
           date2=this.timeInit.getYMDHMS(this.creatTime[1])
        }else{
            date1=null
            date2=null
        }
        let setParams = {
            sTime:date1,
            eTime:date2,
            page: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
            status:this.status
         }
        this.request.get("/front/polling/record/recordPageList", setParams).then(res => {
          console.log(res)
          this.tableLoading = false;
          if (res.code == 200) {
            this.dataList = res.data.pageData
            this.pagination.total = res.data.total;
          } else if (res.code == 500) {
            this.msg.warn(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })

      },
      serachData() {
        //查询//搜索
        console.log(this.creatTime);
        
        if(this.creatTime==null){
          this.msg.warn('请选择正确的时间段进行查询！')
          return
        }
        this.pagination.currentPage = 1;
        this.initData();
      },
      //表格当前页变化时
      handleRoleCurrentChange(val) {
        this.pagination.currentPage = val;
        this.initData();
      },
      //表格展示条数变化时
      handleRoleSizeChange(val) {
        this.pagination.pageSize = val;
        this.pagination.currentPage = 1;
        this.initData();
      },
      seeClick(row) {
        //查看
        this.dataOne = row;
        this.dialogTableVisible = true;
      },
      closeDialog() {
        //关闭
        this.dialogTableVisible = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .inspectionRecord {
    .query {
      margin-bottom: 20px;
    }

    .topTabs {
      height: 40px;
      background: #fff;
    }

    .mainContent {
      margin: 12px;
      padding: 15px 20px;
      background: #fff;
      box-sizing: border-box;
      overflow: auto;
      .edit {
        background: #327ae6;
        color: #fff;
        cursor: pointer;
      }
      .noedit {
            pointer-events: none;
             color: #8cc5ff;
            background-color: #ecf5ff;
            }
      .del {
        background: #eaa13a;
        color: #fff;
      }
    }
  }
</style>
<style lang="scss">
  .inspectionRecord {
    .query {
      .el-input {
        width: 380px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }

      .el-range-editor.el-input__inner {
        height: 36px;
        line-height: 36px;
        padding: 5px 10px;
        margin-right: 10px;
      }
    }
    .el-dialog {
      .el-dialog__title {
        line-height: 14px;
        font-size: 14px;
        color: #717171;
      }
    }
  }
</style>
